import { FieldArray, useFormikContext, ErrorMessage } from "formik";
import { Card, CardBody, Col, Row, Label, Input, FormGroup } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import { Plus, Trash2 } from "react-feather";

interface FAQ {
  question: string;
  answer: string;
}

interface BlogFormValues {
  faqs: FAQ[];
  [key: string]: any;
}

const FAQSection = () => {
  const { values, setFieldValue, errors, touched } =
    useFormikContext<BlogFormValues>();

  return (
    <Card>
      <CardBody>
        <Row>
          <Col>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="mb-0" style={{ color: "#28797c" }}>FAQs (Frequently Asked Questions)</h5>
            </div>
            <p className="text-muted mb-4">
              Add questions and answers to help your readers understand the topic better.
            </p>

            <FieldArray name="faqs">
              {({ push, remove }) => (
                <>
                  {values.faqs && values.faqs.length > 0 ? (
                    values.faqs.map((faq, index) => (
                      <Card key={index} className="mb-3 border">
                        <CardBody>
                          <Row>
                            <Col sm="12">
                              <div className="d-flex justify-content-between align-items-center mb-3">
                                <h6 className="mb-0">FAQ #{index + 1}</h6>
                                <Btn
                                  color="danger"
                                  size="sm"
                                  onClick={() => remove(index)}
                                  title="Remove FAQ"
                                >
                                  <Trash2 size={16} />
                                </Btn>
                              </div>
                            </Col>

                            <Col sm="12">
                              <FormGroup>
                                <Label className="form-label">
                                  Question <span className="text-danger">*</span>
                                </Label>
                                <Input
                                  type="text"
                                  name={`faqs.${index}.question`}
                                  value={faq.question}
                                  onChange={(e) =>
                                    setFieldValue(
                                      `faqs.${index}.question`,
                                      e.target.value
                                    )
                                  }
                                  placeholder="Enter your question here..."
                                  className={
                                    errors.faqs?.[index] &&
                                      typeof errors.faqs[index] === "object" &&
                                      (errors.faqs[index] as any).question &&
                                      touched.faqs?.[index] &&
                                      typeof touched.faqs[index] === "object" &&
                                      (touched.faqs[index] as any).question
                                      ? "is-invalid"
                                      : ""
                                  }
                                />
                                <ErrorMessage
                                  name={`faqs.${index}.question`}
                                  component="div"
                                  className="invalid-feedback d-block"
                                />
                              </FormGroup>
                            </Col>

                            <Col sm="12">
                              <FormGroup>
                                <Label className="form-label">
                                  Answer <span className="text-danger">*</span>
                                </Label>
                                <Input
                                  type="textarea"
                                  name={`faqs.${index}.answer`}
                                  value={faq.answer}
                                  onChange={(e) =>
                                    setFieldValue(
                                      `faqs.${index}.answer`,
                                      e.target.value
                                    )
                                  }
                                  placeholder="Enter your answer here..."
                                  rows={4}
                                  className={
                                    errors.faqs?.[index] &&
                                      typeof errors.faqs[index] === "object" &&
                                      (errors.faqs[index] as any).answer &&
                                      touched.faqs?.[index] &&
                                      typeof touched.faqs[index] === "object" &&
                                      (touched.faqs[index] as any).answer
                                      ? "is-invalid"
                                      : ""
                                  }
                                />
                                <ErrorMessage
                                  name={`faqs.${index}.answer`}
                                  component="div"
                                  className="invalid-feedback d-block"
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    ))
                  ) : (
                    <div className="text-center text-muted py-4">
                      <p>No FAQs added yet. Click the button below to add your first FAQ.</p>
                    </div>
                  )}

                  <Btn
                    color="primary"
                    outline
                    onClick={() => push({ question: "", answer: "" })}
                    className="d-flex align-items-center gap-2"
                  >
                    <Plus size={18} />
                    Add FAQ
                  </Btn>
                </>
              )}
            </FieldArray>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default FAQSection;

